const appConfig = process.env.APP_CONFIG;
export default appConfig;
